import authService, { AUTHORITIES } from './authService';

export default authService;

export { AUTHORITIES };
